import React, { useState } from 'react';
import { UserDtoType } from '../../../types/dto/UserDtoType';
import { UserAvatar } from '../basic/UserAvatar';
import { UserContentContainerHeader } from './UserContentContainerHeader';

type UserContentContainerProps = {
  spoilerShow?: boolean;
  className?: string;
  footerClassName?: string;
  header?: any;
  footer?: any;
  author: UserDtoType;
  text?: string;
  children?: any;
};

export function UserContentContainer({
  spoilerShow,
  author,
  text,
  className,
  header,
  footer,
  footerClassName,
  children
}: UserContentContainerProps) {
  const [showSpoiler, setShowSpoiler] = useState<boolean>(false);
  return (
    <div className={`text-white text-sm ${className || ''}`}>
      <div className="flex px-4 pt-4">
        <UserAvatar className="mr-2" user={author} />
        <div className="flex flex-1 justify-center flex-col">
          {header || <UserContentContainerHeader author={author} />}
        </div>
      </div>
      {spoilerShow ? (
        <p className="px-4 pt-2 whitespace-pre-line">{text}</p>
      ) : null}
      {/* <p className="px-4 pt-2 whitespace-pre-line">
        {text.split(/(<sp>[^<]*<\/sp>)/).map((splitText, index) => {
          if (splitText.startsWith('<sp>') && splitText.endsWith('</sp>')) {
            if (!showSpoiler)
              return (
                <span
                  onClick={() => setShowSpoiler(!showSpoiler)}
                  key={index}
                  className="no-selection bg-black hover-pointer text-black"
                >
                  {splitText.slice(4, -5)}
                </span>
              );
            else {
              return (
                <span
                  onClick={() => setShowSpoiler(!showSpoiler)}
                  key={index}
                  className="bg-gray-light"
                >
                  {splitText.slice(4, -5)}
                </span>
              );
            }
          } else {
            return splitText;
          }
        })}
      </p> */}
      {children}
      {footer ? (
        <div className={`flex px-4 py-4 ${footerClassName || ''}`}>{footer}</div>
      ) : null}
    </div>
  );
}
